
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class ElementStudioWidthAdjustmentBarAdjustmentHandle extends Vue {
  @Prop()
  onDragging!: (e: MouseEvent, lastMouseX?: number) => void;

  lastMouseX = 0;

  draggingFunc(e: MouseEvent) {
    e.preventDefault();

    this.onDragging(e, this.lastMouseX);
    this.lastMouseX = e.clientX;
  }

  dragStart(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    document.addEventListener("mousemove", this.draggingFunc);

    document.addEventListener("mouseup", this.dragEnd);
    this.lastMouseX = e.clientX;

    /* Without this, once the mouse goes over the iframe, the mousemove event stops firing
     * Because the cursor would be inside the iframe */
    // @ts-ignore
    document.getElementById("iframe").style.pointerEvents = "none";
  }

  dragEnd(e: MouseEvent) {
    e.preventDefault();

    document.removeEventListener("mousemove", this.draggingFunc);
    document.removeEventListener("mouseup", this.dragEnd);

    // @ts-ignore
    document.getElementById("iframe").style.pointerEvents = "auto";
  }
}
